import { Link } from "react-router-dom";
import { useBranding } from "@/lib/branding";
import WorkspaceSwitcher from "@/components/WorkspaceSwitcher";
import UserMenu from "@/components/UserMenu";

export default function TopBar({ step, totalSteps = 5, title }) {
  const { branding, logoUrl } = useBranding();
  const primary = branding.primary_color || "#C5A880";
  const initial = (branding.firm_name || "L").trim().charAt(0).toUpperCase() || "L";

  return (
    <header
      className="fixed top-0 inset-x-0 z-40 backdrop-blur-xl bg-[#0A0C10]/80 border-b border-white/5"
      data-testid="app-top-bar"
    >
      <div className="max-w-2xl mx-auto px-4 py-3 flex items-center justify-between gap-3">
        <Link to="/dashboard" className="flex items-center gap-2" data-testid="logo-link">
          {logoUrl ? (
            <img
              src={logoUrl}
              alt={branding.firm_name}
              className="w-8 h-8 rounded-lg object-cover border"
              style={{ borderColor: `${primary}99` }}
              data-testid="brand-logo-img"
            />
          ) : (
            <div
              className="w-8 h-8 rounded-lg border flex items-center justify-center"
              style={{ borderColor: `${primary}99` }}
            >
              <span
                className="font-display font-bold text-sm"
                style={{ letterSpacing: "-0.04em", color: primary }}
              >
                {initial}
              </span>
            </div>
          )}
          <div className="leading-tight hidden sm:block">
            <div
              className="font-display font-bold text-[15px] tracking-tight"
              data-testid="brand-firm-name"
            >
              {branding.firm_name}
            </div>
            {branding.tagline ? (
              <div className="overline text-[9px]" style={{ color: `${primary}B3` }}>
                {branding.tagline}
              </div>
            ) : null}
          </div>
        </Link>

        {step ? (
          <div className="flex-1 max-w-[180px] mx-2">
            <div className="flex items-center gap-1.5">
              {Array.from({ length: totalSteps }).map((_, i) => (
                <div
                  key={`step-${i + 1}`}
                  data-testid={`step-indicator-${i + 1}`}
                  className="h-[3px] flex-1 rounded-full transition-all duration-500"
                  style={{
                    background: i + 1 <= step ? primary : "rgba(255,255,255,0.10)",
                  }}
                />
              ))}
            </div>
            <div className="mt-1.5 overline text-[10px] text-white/50">
              Step {step} of {totalSteps} · {title}
            </div>
          </div>
        ) : null}

        <div className="flex items-center gap-2">
          <WorkspaceSwitcher />
          <UserMenu />
        </div>
      </div>
    </header>
  );
}
